import type { ForkHireEmailProvisioningResult } from '@/lib/forkhireEmailProvisioning';

type SuccessfulForkHireProvisioning = Extract<ForkHireEmailProvisioningResult, { ok: true }>;

export function getForkHireProtectedBootstrapRedirect(provisioning: SuccessfulForkHireProvisioning) {
  return provisioning.redirectTo === '/dashboard' ? null : provisioning.redirectTo;
}
